import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { FileAttachment } from "../components/model/file-attachement";

const initialState: FileAttachment[] = Array(0);

const fileSlice = createSlice({
  name: "file-attachment",
  initialState,
  reducers: {
    setFileAttachments: (state, action: PayloadAction<FileAttachment>) => {
      const currentFile = state.find((file) => file.id === action.payload.id);
      if (currentFile) {
        let modifiedFile = {
          ...currentFile,
          name: action.payload.name,
          file: action.payload.file,
        };
        const newState = [
          modifiedFile,
          ...state.filter((file) => file.id !== action.payload.id),
        ];
        return newState;
      } else {
        return [
          {
            id: action.payload.id,
            name: action.payload.name,
            file: action.payload.file,
            size: action.payload.size,
          } as FileAttachment,
          ...state,
        ];
      }
    },
    removeFileAttachments: (state, action: PayloadAction<string>) => {
      return [...state.filter((file) => file.id !== action.payload)];
    },
  },
});

export const setFileAttachment = (fileAttachment: FileAttachment) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(fileActions.setFileAttachments(fileAttachment));
  };
};

export const removeFileAttachment = (fileAttachment: string) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(fileActions.removeFileAttachments(fileAttachment));
  };
};

export default fileSlice;
export const fileActions = fileSlice.actions;
